export default __webpack_public_path__ + "static/media/download.a0e0820d.png";